import store from '@/store'
import {
  VERIFICATION_REQUEST_GET_LIST,
  VERIFICATION_REQUEST_SET_TOKEN,
  // GLOBAL_SET_LOADING,
  // GLOBAL_SET_FINISHED,
} from '@/store/types'

import VerificationRequestBase from '@/views/verification_request/Base.vue'

export default {
  path: '/verifications',
  name: 'verification_request_base',
  component: VerificationRequestBase,
  beforeEnter: async (to, _, next) => {
    if (to.query.token) {
      await store.dispatch(VERIFICATION_REQUEST_SET_TOKEN, to.query.token)
    }

    if (!store.getters.getVerificationRequests) {
      try {
        // store.commit(GLOBAL_SET_LOADING)
        await store.dispatch(VERIFICATION_REQUEST_GET_LIST)
        // store.commit(GLOBAL_SET_FINISHED)
        if (
          store.getters.getVerificationRequests.every((r) =>
            ['expired', 'closed'].includes(r.status),
          )
        ) {
          next({ name: 'verification_request_expired' })
          return false
        } else if (store.getters.getVerificationRequests.every((r) => r.status === 'completed')) {
          next({ name: 'verification_request_completed' })
          return false
        }
      } catch {
        next({ name: 'error', params: { code: '403' } })
        return false
      }
    }

    next()
  },
  children: [
    {
      path: 'documents',
      name: 'verification_request_document_base',
      component: () => import('@/views/verification_request/documents/Base.vue'),
      children: [
        {
          path: 'start',
          name: 'verification_request_document_landing',
          component: () => import('@/views/verification_request/documents/Landing.vue'),
        },
        {
          path: ':id/document_type',
          name: 'verification_request_document_type',
          component: () => import('@/views/verification_request/documents/DocumentType.vue'),
        },
        {
          path: ':id/upload/:document_type',
          name: 'verification_request_document_upload',
          component: () => import('@/views/verification_request/documents/Upload.vue'),
        },
        {
          path: 'success',
          name: 'verification_request_document_success',
          component: () => import('@/views/verification_request/documents/Success.vue'),
        },
      ],
    },
    {
      path: 'questionnaire',
      name: 'verification_request_questionnaire_base',
      component: () => import('@/views/verification_request/questionnaire/Base.vue'),
      children: [
        {
          path: 'start',
          name: 'verification_request_questionnaire_landing',
          component: () => import('@/views/verification_request/questionnaire/Landing.vue'),
        },
        {
          path: ':id/questions',
          name: 'verification_request_questionnaire_questions',
          component: () => import('@/views/verification_request/questionnaire/Questions.vue'),
        },
        {
          path: ':id/success',
          name: 'verification_request_questionnaire_success',
          component: () => import('@/views/verification_request/questionnaire/Success.vue'),
        },
      ],
    },

    {
      path: 'expired',
      name: 'verification_request_expired',
      component: () => import('@/views/verification_request/Expired.vue'),
    },

    {
      path: 'completed',
      name: 'verification_request_completed',
      component: () => import('@/views/verification_request/Completed.vue'),
    },
  ],
}
